import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <img
    src="/images/logo.webp"
    alt="TRAILNONE monogram"
    className={`brand-logo object-contain ${className}`}
  />
);

export const Logo = () => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-lg font-bold uppercase tracking-[0.18em]">
      Trailnone
    </span>
  </Link>
);
